/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: BaseService.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/app/base/BaseService.js
 */

export default class BaseService {
    constructor(props) {
        this.selectCustomer = (props && props.customer) ? props.customer : process.env.VUE_APP_CUSTOMER_ID
        this.appCustomer = process.env.VUE_APP_CUSTOMER_ID
    }

    setCustomer(customer) {
        this.selectCustomer = customer
    }

    makeUrl(url, params) {
        if (params) {
            Object.keys(params).map(param => {
                url = url.replace(':' + param, params[param])
            })
        }

        return url
    }
}
